module.exports = __webpack_public_path__ + "static/011-0c4baa0d8e29aa8ed65f3aebd26c860d.jpg";